import { keys, reduce, isNil, isEmpty, get, includes } from 'lodash';
import { Validations } from '@utils/helpers';
import { IError } from '@utils/useForm';
import { PaymentForm } from '@models/MLTC/Payment.model';

export const validate = (values: PaymentForm) => {
  const fields = keys(values);
  const errors: any = reduce(fields, (result, field: string) => {
    return { ...result, [field]: validateField(values, field) };
  }, {});
  return errors;
}

export const validateField = (values: any, name: string) => {
  const value = values[name];
  let error: IError | undefined = { isValid: true };
  switch (name) {
    case 'others':
      if (values['bank'] === '11') {
        if (isNil(value)) {
          error = { isValid: false }
        } else {
          if (isEmpty(value)) {
            error = { isValid: false, message: "Please enter the credit card issuing bank's name" }
          }
          if (!Validations.isDutyOfOccupationValid(value)) {
            error = { isValid: false, message: "Please don't include special characters other than hyphens (-) or apostrophes (')" }
          }
        }

      }
      break;
    case 'name':
      if (isNil(value)) {
        error = { isValid: false };
      } else {
        if (isEmpty(value.trim())) {
          error = { isValid: false, message: "Please enter a valid name" };
        }
      }
      break;
    case 'no':
    case 'bank':
      if (isNil(value) || isEmpty(value)) {
        error = { isValid: false };
      }
      break;
    case 'fund':
      if (isNil(value) || get(value, 'length', 0) === 0) {
        error = { isValid: false };
      } else {
        if (includes(value, 'other') && isNil(values['otherFund'])) {
          error = { isValid: false };
        }
      }
      break;
    case 'otherFund':
      const fund = values['fund'];
      console.log('source of fund', {fund, values});
      if (includes(fund, 'other')) {
        if (isNil(value)) {
          error = { isValid: false, message: 'Please specify your source of funds' };
        } else {
          if (isEmpty(value)) {
            error = { isValid: false, message: 'Please specify your source of funds' };
          }
          if (!Validations.isDutyOfOccupationValid(value)) {
            error = { isValid: false, message: "Please don’t include special characters other than hyphens (-) or apostrophes (')" };
          }
        }
      }
      break;
    case 'isAuthorised':
      if (isNil(value) || value === false) {
        error = { isValid: false };
      }
      break;
  }
  return error;
}